const TO_DO_STATUS = 'TO_DO';
const NOT_ACCEPTED_STATUS = 'NOT_ACCEPTED';

const TO_DO_COLUMNS = [
	'No.',
	'Rynek',
	'Imię i nazwisko',
	'Data zgłoszenia',
	'Zwrot',
	'Kwota',
	'Waluta',
	'Dokument',
	'Przycisk akcji',
];

const NOT_ACCEPTED_COLUMNS = [
	'No.',
	'Rynek',
	'Imię i nazwisko',
	'Data zgłoszenia',
	'Data odmowy zwrotu',
	'Kwota',
	'Waluta',
	'Dokument',
	'Status zwrotu',
	'Komentarz',
];

const DONE_COLUMNS = [
	'No.',
	'Rynek',
	'Imię i nazwisko',
	'Data zgłoszenia',
	'Data zwrotu',
	'Kwota',
	'Waluta',
	'Dokument',
	'Status zwrotu',
];

export const getRefundTableHeaders = (status) => {
	if (status === TO_DO_STATUS) {
		return TO_DO_COLUMNS;
	}

	if (status === NOT_ACCEPTED_STATUS) {
		return NOT_ACCEPTED_COLUMNS;
	}

	return DONE_COLUMNS;
};
